module.exports = __webpack_public_path__ + "static/media/listening_image2.2ccbc8c1.webp";